import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    alignSelf: 'stretch',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  title: (theme, isBold) => ({
    color: theme.colors.textColorThree,
    fontWeight: isBold ? 'bold' : 'normal',
    fontSize: 16,
    lineHeight: 22,
  }),
  value: theme => ({
    fontWeight: 'bold',
    fontSize: 16,
    lineHeight: 22,
    color: theme.colors.textColorThree,
  }),
});
